module.exports = __webpack_public_path__ + "img/man-body-back.041c4bb8.png";